'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeMesh3dIcon = function TraceTypeMesh3dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement(
            'g',
            { fill: 'none' },
            _react2.default.createElement('path', { d: 'M0 0h46v46H0z' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M23.511 20.062L9.516 13.588l13.929-6.319 14.039 6.319-13.973 6.474zM9.516 13.588v16.75l13.999 6.026-.004-16.302-13.995-6.474z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M37.484 13.588v16.75l-13.999 6.026.004-16.302 13.995-6.474z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M18.489 17.739v16.408M14 15.662V32.5m9.515-1.695L9.516 24.588m13.999 1.217L9.516 19.588m19.026-1.924v16.483m4.489-18.387V32.5m-9.516-1.695l14-6.217m-14 1.217l14-6.217m-23.128-8.21l14.155 6.286m-9.814-8.255l14.303 6.351m-14.542 1.979l14.124-6.292M14 15.662l14.123-6.291', strokeLinecap: 'round', strokeLinejoin: 'round' })
        )
    );
};

exports.default = TraceTypeMesh3dIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeMesh3dIcon.js
// module id = 718
// module chunks = 0